module.exports = __webpack_public_path__ + "img/vertical_7_3_3009.87423e90.png";